import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { Primary, PrimaryMedium } from "@ui/components/containers/primary";
import { ChevronDownIcon } from "./icons";
import { row, stack } from "./layout";
import { Menu } from "@ui/components/menus/menu";

export type Content = "courses" | "quizzes" | "articles" | "carousels";
interface ContentSelectorProps extends React.HTMLAttributes<HTMLDivElement> {
	currentContent: Content;
	onContentChange: (newContent: Content) => void;
	isMe?: boolean;
}

export const ContentSelector: React.FC<ContentSelectorProps> = ({
	isMe,
	currentContent,
	onContentChange,
	...htmlProps
}) => {
	const wording = (content: Content): string =>
		I18n.t(isMe ? `profile.content_self.${content}` : `profile.content.${content}`);

	return (
		<Menu
			bottomSheetMode
			closeOnSelect
			align="left"
			{...htmlProps}
			renderMenuContent={() => (
				<Content>
					{(["courses", "quizzes", "articles", "carousels"] as const).map((content) => (
						<Row
							style={{ width: "max-content" }}
							key={content}
							selected={content === currentContent}
							onClick={() => onContentChange(content)}
						>
							{wording(content)}
						</Row>
					))}
				</Content>
			)}
		>
			<Container>
				<div>{wording(currentContent)}</div>
				<ChevronDownIcon />
			</Container>
		</Menu>
	);
};

const Container = styled(Primary)`
	${row(10, "center", "center")};
	padding: 8px 12px;
	border-radius: 18px;
	background-color: ${({ theme }) => theme.colors.lightergray};
	color: ${({ theme }) => theme.colors.textSecondary};
	font-weight: bold;

	> svg {
		width: 14px;
		path {
			fill: ${({ theme }) => theme.colors.textSecondary};
		}
		display: block;
	}
`;

const Content = styled.div`
	${stack(20)}
`;

const Row = styled(PrimaryMedium)<{ selected: boolean }>`
	cursor: pointer;
	${({ selected, theme }) => selected && `color: ${theme.colors.secondary}`};
`;
